import { isPastMaintenanceMode, SYSTEM_MAINTENANCE_MESSAGE } from "../app/SystemMaintenanceModeUtils"
import { ErrorPanel } from "./MessagePanels/Panels"

/**
 * This component will show the SYSTEM_MAINTENANCE_MESSAGE 
 * from the times its activated till the time the maintenance mode is enabled 
 */
export const SystemMaintenanceMessage = () => {

    if(isPastMaintenanceMode()) {
        return null
    }

    return (<div className="row">
                <div className="col-lg-8">
                <ErrorPanel>
                    {SYSTEM_MAINTENANCE_MESSAGE}
                </ErrorPanel>
                </div>
            </div>)
}